var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 10.6666C1.33325 8.78101 1.33325 7.8382 1.91904 7.25241C2.50482 6.66663 3.44763 6.66663 5.33325 6.66663H10.6666C12.5522 6.66663 13.495 6.66663 14.0808 7.25241C14.6666 7.8382 14.6666 8.78101 14.6666 10.6666C14.6666 12.5522 14.6666 13.4951 14.0808 14.0808C13.495 14.6666 12.5522 14.6666 10.6666 14.6666H5.33325C3.44763 14.6666 2.50482 14.6666 1.91904 14.0808C1.33325 13.4951 1.33325 12.5522 1.33325 10.6666Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99976 6.66671V5.33337C3.99976 3.12424 5.79062 1.33337 7.99976 1.33337C10.2089 1.33337 11.9998 3.12424 11.9998 5.33337V6.66671",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7cdb4bf3510c808975d6804fdfd6dd93.svg";
export { ForwardRef as ReactComponent };